import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import axios from "axios";
import Header from "../Header/Header.jsx";
import Footer from "../Footer/Footer.jsx";
import "react-quill-new/dist/quill.snow.css";

const EventDetail = () => {
  const location = useLocation();
  const { idx } = useParams(); // URL에서 idx 가져오기
  const [newsItem, setNewsItem] = useState(null);
  const [, setNewsList] = useState([]); // 전체 뉴스 목록 상태 추가

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 | 아소비 이벤트 상세`;

    // 페이지 뷰 추적
    window.gtag("config", "G-LYT78YCDYK", {
      page_path: location.pathname,
    });

    const fetchNewsDetail = async () => {
      const response = await axios.get("/boards");
      const event = response.data;

      const filteredNews = event.filter((item) => item.gubun === "BB02");

      // 전체 뉴스 목록 저장
      setNewsList(filteredNews);

      // idx로 필터링하여 해당 뉴스 찾기
      const selectedNews = event.find((item) => item.idx === parseInt(idx));
      setNewsItem(selectedNews);
    };

    fetchNewsDetail();
  }, [idx, location]);

  const copyToClipboard = () => {
    const url = `${window.location.origin}/news_detail/${idx}`;
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(url)
        .then(() => {
          alert("Ctrl+V로 붙여 넣으세요.");
        })
        .catch((err) => {
          console.error("URL 복사 실패:", err);
        });
    } else {
      // navigator.clipboard를 지원하지 않는 경우
      const textArea = document.createElement("textarea");
      textArea.value = url;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        alert("Ctrl+V로 붙여 넣으세요.");
      } catch (err) {
        console.error("URL 복사 실패:", err);
      }
      document.body.removeChild(textArea);
    }
  };

  if (!newsItem) return <div>로딩 중...</div>;

  const cleanContent = newsItem.content.replace(/%20/g, ""); // %20을 빈 문자열로 대체

  return (
    <div>
      <Header />
      <section id="container">
        <div className="subvisual">
          <div className="title">아소비 이벤트</div>
          <div className="text">
            다양한 아소비 이벤트 참여하고 혜택도 받으세요!
          </div>
        </div>
        <div className="event">
          <div className="wrap">
            <div className="detail">
              <div className="head">
                <div
                  className={`cate ${
                    new Date(newsItem.bdEnd) < new Date() ? "end" : ""
                  }`}
                >
                  <span>
                    {new Date(newsItem.bdEnd) >= new Date()
                      ? "진행 중"
                      : "종료"}
                  </span>
                </div>
                <div className="subj">{newsItem.title}</div>
                <div className="date">
                  {newsItem.bdStart} ~ {newsItem.bdEnd}
                </div>
                <input
                  type="button"
                  className="link_obj"
                  value="URL"
                  onClick={copyToClipboard}
                  style={{ cursor: "pointer" }}
                />
              </div>
              <div
                className="cont ql-editor"
                dangerouslySetInnerHTML={{ __html: cleanContent }}
              />
              <div className="button">
                <a href="/event" className="btn btn_01">
                  목록
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default EventDetail;
